module.exports = __webpack_public_path__ + "img/db_hero_img_pc.6ba9c561.png";